export default __webpack_public_path__ + "static/media/driver-icon-red.d8b32fdc.svg";